import gql from "graphql-tag"

export const uploadForm = gql`
  mutation uploadForm($category_id: ID!, $answers: JSON, $description: String, $file: Upload, $person: uploadPersonInput!, $recaptchatoken: String) {
    uploadForm(input: {category_id: $category_id, answers: $answers, description: $description, file: $file, person: $person}, recaptchatoken: $recaptchatoken) {
      success
    }
  }
`
